module.exports = __webpack_public_path__ + "assets/images/order_devices.png";